<template>
  <div class="home" v-if="showHome">
    <template v-if="pageType == 1">
      <div class="user-information">
        <div class="user">
          <p class="con_tit"><span></span><strong>会员信息</strong></p>
          <div class="con_top">
            <div class="con_top_top">
              <p>
                {{ name }} <span>会员编号：{{ bh }}</span
                ><i v-show="note === 1"
                  >（该企业还未通过中国质量协会秘书处审批，最终会员信息以红头文件为准。）</i
                >
              </p>
              <strong v-show="person" class="card" @click="myCard"
                >我的会员卡</strong
              >
            </div>
            <div class="con_top_bot">
              <ul class="con_top_bot_left">
                <li>
                  会员有效期：<span :class="note == 1 ? 'red' : ''">{{
                    data
                  }}</span>
                </li>
                <li>
                  缴费状态：<span
                    :class="
                      type == '已退会'
                        ? 'red'
                        : type == '冻结'
                        ? 'red'
                        : type == '待缴费'
                        ? 'red'
                        : 'type'
                    "
                    >{{ type }}</span
                  >
                </li>
                <li>
                  会员联系人：<span>{{ lxr }}</span>
                </li>
                <li>联系电话：{{ phone }}</li>
                <li>会员类型：{{ zhiwei }}</li>
                <li>
                  电子邮箱：<span>{{ email }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="file-down">
          <div class="con_tit">
            <span></span><strong>协会文件</strong>
            <p class="more" @click="tab(2)">更多</p>
          </div>
          <ul>
            <li
              v-for="(item, index) in noticeList"
              :key="index"
              @click="viewFile(item)"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
      <div class="con_bot">
        <div class="con_bot_left">
          <h5><span></span><strong>活动通告</strong></h5>
          <div>
            <!--对数据请求的处理，最为重要的一句话-->

            <ul
              :data="
                allTableData1.slice(
                  (paginations1.page_index - 1) * paginations1.page_size,
                  paginations1.page_index * paginations1.page_size
                )
              "
            >
              <li v-for="(item, index) in tableData1">
                <a :href="item.url" target="_blank">
                  <p>{{ item.title }}</p>
                  <span>{{ item.time }}</span></a
                >
              </li>
            </ul>
            <el-pagination
              style="
                width: 70%;
                height: 35px;
                border: none;
                padding: 0;
                margin: 0 auto;
                text-align: center;
              "
              @size-change="handleSizeChange1"
              @current-change="current1"
              :page-size="paginations1.page_size"
              :current-page="paginations1.page_index"
              :layout="paginations1.layout"
              :total="paginations1.total"
            >
            </el-pagination>
          </div>
        </div>
        <div class="con_bot_right">
          <h5><span></span><strong>通知提醒</strong></h5>
          <div>
            <!--对数据请求的处理，最为重要的一句话-->
            <ul
              :data="
                allTableData.slice(
                  (paginations.page_index - 1) * paginations.page_size,
                  paginations.page_index * paginations.page_size
                )
              "
            >
              <li v-for="(item, index) in tableData">
                <p>{{ item.desc }}</p>
                <span>{{ item.created_at }}</span>
              </li>
            </ul>
            <el-pagination
              style="
                width: 90%;
                height: 35px;
                border: none;
                padding: 0;
                text-align: center;
              "
              @size-change="handleSizeChange"
              @current-change="current"
              :page-size="paginations.page_size"
              :current-page="paginations.page_index"
              :layout="paginations.layout"
              :total="paginations.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="shade" v-show="show" @click.self="hide">
        <div class="myCard" @mousemove="getCard">
          <p class="myCardname">
            <strong>{{ name1 }}</strong>
            <span>No. {{ bh }}</span>
          </p>
          <p class="myCardnum">
            <span>身份证：{{ cardNum }}</span>
            <i
              >有效期：<strong :class="note == 1 ? 'red' : ''">{{
                data
              }}</strong></i
            >
          </p>
        </div>
      </div>
    </template>
    <template v-else-if="pageType === 2">
      <div class="pageNav">
        <span @click="tab(1)">会员首页</span> 》协会文件
      </div>
      <ul class="filedownLists">
        <li
          @click="viewFile(item)"
          v-for="(item, index) in noticeList"
          :key="index"
        >
          <p>{{ item.title }}</p>
          <span>{{ item.time }}</span>
        </li>
      </ul>
    </template>
    <template v-else-if="pageType === 3">
      <div class="nav">
        <a href="javascript:;" @click="tab(1)">会员首页</a> 》协会文件 》<span
          >{{ curFileobj.title }}</span
        >
      </div>
      <!-- <div class="pageTitle">{{ curFileobj.title }}</div> -->
      <div class="pageContent">
        <el-image style="width: 100%" :src="curFileobj.image"></el-image>
      </div>
      <!-- <div class="pageNav">
        <span @click="tab(1)">会员首页</span> 》<span @click="tab(2)"
          >协会文件</span
        >
        <template v-if="curFileobj.title"> 》 </template>
        {{ curFileobj.title }}
      </div>
      <div class="pic" id="disableClick" v-if="curFileobj.imageList.length">
        <div
          class="pic-list"
          v-for="(item, index) in curFileobj.imageList"
          :key="index"
        >
          <el-image style="width: 100%" :src="item"></el-image>
        </div>
      </div> -->
    </template>
  </div>
</template>

<script>
import Qs from 'qs'
export default {
  props: {
    pageType: {
      type: Number
    },
    showHome: {
      type: Boolean
    }
  },
  data () {
    return {
      curFileobj: {},
      // pageType: 1,//1为首页2为协会文件3为文件内容页
      noticeList: [
        { title: '中国质量协会章程', link: 'https://www.caq.org.cn/html/zjxh/gywm/295.html', time: '', type: 'jump' },
        { title: '中国质量协会会员管理办法', link: 'https://www.caq.org.cn/html/hytd/hyfw/16012.html', time: '', type: 'jump' },
        { title: '中国质量协会会费管理办法', link: 'https://www.caq.org.cn/html/hytd/hyfw/15381.html', time: '', type: 'jump' },
        { title: '关于缴纳中国质量协会2026年度会费的通知', link: ' https://www.caq.org.cn/1226.html', time: '', type: 'jump' },

      ],
      fileDownList: [
        {
          title: '中国质量协会章程', imageList: [
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/0.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/1.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/2.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/3.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/4.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/5.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/6.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/7.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/8.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/9.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/10.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/11.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/12.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/13.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/14.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/15.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/16.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/17.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/18.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/19.png',
            'https://frontend.caq.org.cn/static/img/fileImages/zhangcheng2309/20.png'
          ], time: ''
        },
        {
          title: '中国质量协会会员管理办法', imageList: [
            'https://frontend.caq.org.cn/static/img/fileImages/member-manage/1.JPG?v=2',
            'https://frontend.caq.org.cn/static/img/fileImages/member-manage/2.JPG?v=2',
            'https://frontend.caq.org.cn/static/img/fileImages/member-manage/3.JPG?v=2',
            'https://frontend.caq.org.cn/static/img/fileImages/member-manage/4.JPG?v=2',
            'https://frontend.caq.org.cn/static/img/fileImages/member-manage/5.JPG?v=2',
            'https://frontend.caq.org.cn/static/img/fileImages/member-manage/6.JPG?v=2',
            'https://frontend.caq.org.cn/static/img/fileImages/member-manage/7.JPG?v=2'
          ], time: ''
        },
        {
          title: '中国质量协会会费管理办法', imageList: [
            'https://frontend.caq.org.cn/static/img/fileImages/manage/1.png',
            'https://frontend.caq.org.cn/static/img/fileImages/manage/2.png'
          ], time: ''
        }
      ],
      name: '',
      name1: '',
      bh: '',
      data: '',
      type: '',
      zhiwei: '',
      lxr: '',
      phone: '',
      email: '',
      note: '',
      cardNum: '',
      show: false,
      person: false,
      tableData: [], //数据
      paginations: {
        page_index: 1, //当前页
        total: 0, //总数
        page_size: 5, //一页显示多少
        layout: 'prev, pager, next'
      },
      allTableData: [], //    每页的数据	
      tableData1: [], //数据
      paginations1: {
        page_index: 1, //当前页
        total: 0, //总数
        page_size: 5, //一页显示多少
        layout: 'prev, pager, next'
      },
      allTableData1: [] //    每页的数据	

    };
  },
  created () {
    this.getInfoList1();
    this.getInfoList();
  },
  mounted () {
    window.document.oncontextmenu = function () {
      return false;
    }
    if (sessionStorage.getItem('name')) {
      this.name = sessionStorage.getItem('name');
    };
    if (sessionStorage.getItem('bh')) {
      this.bh = sessionStorage.getItem('bh');
    };
    if (Number(sessionStorage.getItem('type')) == 3) {
      this.person = true;
    };
    if (sessionStorage.getItem('Token')) {
      var token = sessionStorage.getItem('Token');
    };
    var data1 = {
      'access-token': token
    };
    this.$axios({
      method: 'post',
      url: 'personal/applicationform',
      data: Qs.stringify(data1)
    }).then(response => {
      if (response.data.state == 2) {
        if (response.data.data.length != 0) {
          this.name1 = response.data.data.name;
        }
      }
    });
    //会员信息
    this.$axios({
      method: 'post',
      url: 'company/memberstatus',
      data: Qs.stringify(data1)
    }).then(response => {
      if (response.data.state == 3) {
        this.data = response.data.result.endTime;
        this.type = response.data.result.PaymentValidNow;
        this.zhiwei = response.data.result.role;
        this.email = response.data.result.user_email;
        this.phone = response.data.result.user_phone;
        this.lxr = response.data.result.user_name;
        this.note = response.data.result.note;
      } else if (response.data.state == 4) {
        this.data = response.data.result.endTime;
        this.type = response.data.result.PaymentValidNow;
        this.zhiwei = response.data.result.role == '会员' ? '个人会员' : response.data.result.role;
        this.email = response.data.result.email;
        this.phone = response.data.result.mobile;
        this.cardNum = response.data.result.id_number;
      } else if (response.data.state == 66) {
        //					this.$toast(response.data.msg);
      }
    });
  },
  methods: {
    viewFile (obj) {
      if (obj.type === 'jump') {
        location.href = obj.link
      } else {
        this.$emit('changePageType', 3)
        this.curFileobj = obj
      }
      // this.$emit('changePageType', 3)
      // this.pageType = 3
      // this.curFileobj = obj
    },
    tab (sn) {
      // location.href = 'https://www.caq.org.cn/html/hytd/index.html'
      this.$emit('changePageType', sn)
      // this.pageType = sn
    },
    getCard (event) {
      var bd = document.body;
      var card = document.querySelector(".myCard")
      var w = window.innerWidth / 2;
      var x = event.clientX;
      if (x > w + 100) {
        card.style.transform = "rotateY(4deg)";
      }
      if (x > w - 100 && x < w + 100) {
        card.style.transform = "rotateY(0deg)";
      }
      if (x < w - 100) {
        card.style.transform = "rotateY(-4deg)";
      }
    },
    //查看我的会员卡
    myCard () {
      this.show = true;
    },
    hide () {
      this.show = false;
    },
    //去缴纳会费页面
    childMethod () {
      this.$parent.tabNav(1);
    },
    getInfoList1 () {
      //会员动态	
      if (sessionStorage.getItem('Token')) {
        var token = sessionStorage.getItem('Token');
      };
      var data1 = {
        'access-token': token
      };
      this.$axios({
        method: 'post',
        url: 'newsmessage/messagesleft',
        data: Qs.stringify(data1)
      }).then(response => {
        if (response.data.state == 1) {
          this.allTableData1 = response.data.List;
          this.setPaginations1();
        }
      });
    },

    getInfoList () {
      //会员活动数据
      if (sessionStorage.getItem('Token')) {
        var token = sessionStorage.getItem('Token');
      };
      var data1 = {
        'access-token': token
      };
      this.$axios({
        method: 'post',
        url: 'newsmessage/indexrightnotice',
        data: Qs.stringify(data1)
      }).then(response => {
        if (response.data.state == 1) {
          this.allTableData = response.data.ShowData;
          this.setPaginations();
        }
      })
    },

    setPaginations () {
      this.paginations.total = this.allTableData.length; //数据的数量
      this.paginations.page_index = 1; //默认显示第一页
      this.paginations.page_size = 5; //每页显示多少数据
      //显示数据
      this.tableData = this.allTableData.filter((item, index) => {
        return index < this.paginations.page_size;
      })
    },
    setPaginations1 () {
      this.paginations1.total = this.allTableData1.length; //数据的数量
      this.paginations1.page_index = 1; //默认显示第一页
      this.paginations1.page_size = 7; //每页显示多少数据
      //显示数据
      this.tableData1 = this.allTableData1.filter((item, index) => {
        return index < this.paginations1.page_size;
      })
    },
    handleSizeChange (page_size) {
      this.paginations.page_index = 1; //第一页
      this.paginations.page_size = page_size; //每页先显示多少数据
      this.tableData = this.allTableData.filter((item, index) => {
        return index < page_size
      })
    },
    handleSizeChange1 (page_size) {
      this.paginations1.page_index = 1; //第一页
      this.paginations1.page_size = page_size; //每页先显示多少数据
      this.tableData1 = this.allTableData1.filter((item, index) => {
        return index < page_size
      })
    },
    current (page) {
      // 跳转页数
      //获取当前页
      let index = this.paginations.page_size * (page - 1);
      //获取总数
      let allData = this.paginations.page_size * page;

      let tablist = [];
      for (let i = index; i < allData; i++) {
        if (this.allTableData[i]) {
          tablist.push(this.allTableData[i])
        }
        this.tableData = tablist
      }
    },
    current1 (page) {
      // 跳转页数
      //获取当前页
      let index = this.paginations1.page_size * (page - 1);
      //获取总数
      let allData1 = this.paginations1.page_size * page;

      let tablist1 = [];
      for (let i = index; i < allData1; i++) {
        if (this.allTableData1[i]) {
          tablist1.push(this.allTableData1[i])
        }
        this.tableData1 = tablist1
      }
    },

  }
}
</script>
<style scoped>
.home {
  padding: 0 18px;
  min-height: 645px;
  box-sizing: border-box;
}
.red {
  color: red;
}
.pageNav {
  line-height: 40px;
  border-bottom: solid 1px #cfd4d6;
  color: #000;
  font-size: 14px;
}
.pageNav span {
  cursor: pointer;
}
.pic {
  width: 900px;
  margin: 0 auto;
}
/* .pic .el-image .el-image__inner {
  width: 793px;
} */
.filedownLists li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-left: 20px;
  border-bottom: solid 1px #cfd4d6;
  position: relative;
  cursor: pointer;
}
.filedownLists li:before {
  content: "";
  position: absolute;
  left: -10px;
  top: 50%;
  margin-top: -1.5px;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #cfd4d6;
}
.filedownLists li span {
  color: #cfd4d6;
}
.user-information {
  display: flex;
}
.user-information .user {
  width: 57%;
}
.file-down {
  width: 370px;
  padding: 0 15px;
  margin-left: 20px;
}
.file-down ul {
  padding-left: 20px;
  padding-top: 10px;
  height: 165px;
  overflow: hidden;
}
.file-down li {
  display: flex;
  align-items: center;
  height: 37px;
  margin-top: 2px;
  border-bottom: 1px solid #cfd4d6;
  cursor: pointer;
}
.file-down .more {
  cursor: pointer;
}
.shade {
  perspective: 500px;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
}

.myCard {
  width: 529px;
  height: 299px;
  position: absolute;
  left: 35%;
  top: 30%;
  background: url(../../static/img/vipCard.png) no-repeat;
  background-size: 100%;
  transform-style: preserve-3d;
  transition: ease 1s;
}

.myCardname {
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 48px;
  text-align: center;
  transform: translateY(-50%);
}

.myCardname strong {
  font-size: 34px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(64, 64, 64, 1);
  line-height: 48px;
}

.myCardname span {
  font-size: 14px;
  font-family: Thonburi;
  color: rgba(64, 64, 64, 1);
  line-height: 19px;
}

.myCardnum {
  font-size: 14px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(64, 64, 64, 1);
  position: absolute;
  bottom: 36px;
  width: 481px;
  left: 24px;
}

.myCardnum span {
  float: left;
}

.myCardnum i {
  float: right;
}

.con_tit {
  color: #005eb3;
  font-size: 18px;
  line-height: 45px;
  font-weight: bold;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}
.con_tit .more {
  position: absolute;
  right: 0;
  top: 0;
  height: 45px;
  display: flex;
  align-items: center;
  color: #595963;
  font-size: 12px;
  font-weight: normal;
}
.con_tit span {
  width: 4px;
  height: 16px;
  background: #4799e4;
  margin-right: 7px;
}
.con_top {
  padding: 14px 0 20px 18px;
  height: auto;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 15px;
}

.con_top_top {
  width: 100%;
  height: 25px;
  color: #0076ff;
  margin-bottom: 10px;
}

.con_top_top p {
  float: left;
  width: 85%;
  padding-left: 25px;
  background: url(../../static/img/icon2.png) no-repeat top 4px left 0;
  background-size: 16px 17px;
  font-size: 18px;
  font-weight: bold;
  color: #404040;
  box-sizing: border-box;
}

.con_top_top strong {
  cursor: pointer;
  float: right;
  padding-left: 30px;
  background: url(../../static/img/vip.png) no-repeat top left;
  background-size: 25px 20px;
  color: #404040;
}

.con_top_top p span {
  line-height: 24px;
  text-align: center;
  display: inline-block;
  color: #3698ec;
  font-size: 12px;
  height: 24px;
  padding: 0 6px;
  background: rgba(231, 244, 254, 1);
}

.con_top_top p i {
  line-height: 24px;
  text-align: center;
  display: inline-block;
  color: red;
  font-size: 12px;
  height: 24px;
}

.con_top_top div {
  width: 250px;
  height: 100%;
  float: right;
}

.con_top_top a {
  cursor: pointer;
  color: #0076ff;
}

.to_xinxi {
  float: right;
  padding-left: 23px;
  background: url(../../static/img/icon4.png) no-repeat top 2px left 0;
  background-size: 16px 16px;
}

.con_top_bot {
  width: 100%;
  height: 100px;
}

.con_top_bot div {
  display: inline-block;
  padding: 14px 0 0 15px;
  height: 86px;
  background: #f6faff;
}

.con_top_bot_left {
  background: #f6faff;
  padding: 14px 15px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
}
.con_top_bot_left li {
  width: 50%;
  height: 25px;
}

.type {
  color: rgb(90, 187, 170);
}

.con_top_bot_right {
  width: 38%;
  float: right;
}

.con_top_bot_right p {
  margin-bottom: 7px;
}

.con_bot {
  width: 100%;
  height: 410px;
}

.con_bot h5 {
  color: #005eb3;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.con_bot h5 span {
  width: 4px;
  height: 16px;
  background: #4799e4;
  margin-right: 7px;
}

.con_bot_left {
  float: left;
}

.con_bot_left div {
  padding: 0 15px;
  width: 558px;
  height: 385px;
  box-sizing: border-box;
}

.con_bot_left ul {
  width: 100%;
  height: 322px;
  padding-bottom: 20px;
}

.con_bot_left ul a {
  display: block;
  width: 100%;
  height: 46px;
  color: #595959;
  /*line-height: 46px;*/
  border-bottom: 1px solid #cfd4d6;
  box-sizing: border-box;
  font-size: 13px;
}

.con_bot_left p {
  display: inline-block;
  height: 46px;
  width: 400px;
  float: left;
  display: flex;
  align-items: center;
}

.con_bot_left ul a span {
  height: 46px;
  float: right;
  line-height: 46px;
}

.con_bot_right {
  float: right;
}

.con_bot_right div {
  padding: 0 15px;
  width: 380px;
  height: 385px;
  box-sizing: border-box;
}

.con_bot_right ul {
  width: 100%;
  height: 320px;
  padding-bottom: 20px;
}

.con_bot_right ul li {
  font-size: 13px;
  position: relative;
  border-bottom: 1px solid #cfd4d6;
  height: 64px;
  box-sizing: border-box;
}

.con_bot_right li p {
  height: 40px;
  width: 100%;
  color: #595959;
  display: flex;
  align-items: center;
}

.con_bot_right li span {
  position: absolute;
  bottom: 3px;
  left: 0;
  color: #cfd4d6;
}
.nav {
  display: flex;
}
.pageTitle {
  font-weight: bold;
  font-size: 30px;
  text-align: center;
  display: flex;
  align-items: center;
  padding-top: 30px;
  justify-content: center;
}
.pageContent {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue